import PropTypes from 'prop-types';
import React from 'react';
import StyledNotification from './notification.style';

const Notification = props => {
  const { children, type = 'neutral' } = props;
  return <StyledNotification type={type}>{children}</StyledNotification>;
};

Notification.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['error', 'success', 'warning', 'neutral'])
};

export default Notification;
